import React, {useState, useEffect} from "react" ;
import {useRecoilValue} from "recoil";

import { Globals, getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import {getContactMessages} from "root/DataFunctions/MessageDataFns";
import {childDetailsState} from "root/recoil/childDetailsState";
import {MessageFilters, MessageType} from "root/DataFunctions/Constants";
import ChildMessageTable from "root/Tables/ChildMessageTable";
import useModalAddPost from "root/Modals/AddPost/useModalAddPost";

const MessagesNew = (props) => {
    const [messages, setMessages] = useState("");
    const [loading, setLoading] = useState(false);
    const [activeMenu, setActiveMenu] = useState("inbox");
    const childDetails = useRecoilValue(childDetailsState)
    const shouldShowToDropdown = true;

    const [renderAddMessagingModal, showAddMessagingModal] = useModalAddPost((result) =>
    {
        if(result === "saved") {
            handleGetInbox();
        }
    })

    const handleShowMessage = (message, mode, page) => {
        const child_uid = childDetails && mode != 'reply'? childDetails[0].adoptee_user_id : message['sender_user_id'];
        showAddMessagingModal(mode, child_uid, message.post_id, shouldShowToDropdown, MessageType.MESSAGE_TYPE_MESSAGE, page);
    }

    const handleGetInbox = () => {
        setActiveMenu("inbox");
        setLoading(true);

        //Get all incoming messages from all contacts
        getContactMessages( 'user', 'user', MessageFilters.INCOMING, MessageType.MESSAGE_TYPE_MESSAGE,(response) =>
        {
            setMessages(getDataFromResponse(response));
            setLoading(false);
        });
    }

    useEffect(() => {
        handleGetInbox();
    }, []);

    return (
        <>
            <div style={{flex: "1"}}>
                <div className="child_breadcrumb child_breadcrumb-main">
                    <div className="child_breadcrumb_inner">
                        <h2 className="child_breadcrumb_title">Message Inbox</h2>
                    </div>
                </div>

                <div className="child-message-wrap">
                    <div className="child-message-table">
                            {messages && 
                                <ChildMessageTable
                                    tableClass='passport-table-child'
                                    loading={loading}
                                    data={messages}
                                    page="inbox"
                                    showMessageDetail={handleShowMessage}
                                />
                            }
                            
                    </div>

                </div>
            </div>

            {renderAddMessagingModal(props)}
        </>
    );
}

export default MessagesNew;
